import { MODES_INTEGRACIONES } from "features/User/pages/Integraciones/Pages/IntegracionUpdate/contants"
import { withFormik } from "formik"
import { Button } from "primereact/button"
import { InputSwitch } from "primereact/inputswitch"
import { useTranslation } from "react-i18next"

interface valuesModalIntegration {
  logo: string
  type: string
  asientosContables: boolean
  contactos: boolean
  libroIva: boolean
}

const ModalIntegracion = ({
  values,
  setFieldValue,
  handleSubmit,
  onCancel,
}: {
  values: valuesModalIntegration
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (field: string, value: $TSMigrationFixMe) => void
  handleSubmit: () => void
  onCancel: () => void
}) => {
  const { t } = useTranslation()
  return (
    <div>
      <div className='tw-w-full tw-flex tw-flex-col tw-items-start'>
        <img
          className='tw-h-12 tw-object-contain tw-mt-2'
          src={values.logo}
          alt={values.type}
          loading='lazy'
        />
        <span className='tw-mt-4 tw-mb-1 tw-font-medium'>
          {t("integracion.modal.subtitle")}
        </span>
        <div className='tw-h-auto tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-my-2'>
          <span>{t("integracion.modal.contacto")}</span>
          <InputSwitch
            checked={values.contactos}
            onChange={() =>
              setFieldValue(MODES_INTEGRACIONES.CONTACTOS, !values.contactos)
            }
          />
        </div>
        <div className='tw-h-auto tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-my-2'>
          <span>{t("integracion.modal.libroDiario")}</span>
          <InputSwitch
            checked={values.asientosContables}
            onChange={() =>
              setFieldValue(
                MODES_INTEGRACIONES.ASIENTOS_CONTABLES,
                !values.asientosContables
              )
            }
          />
        </div>
        <div className='tw-h-auto tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-my-2'>
          <span>{t("integracion.modal.libroIva")}</span>
          <InputSwitch
            checked={values.libroIva}
            onChange={() =>
              setFieldValue(MODES_INTEGRACIONES.LIBRO_IVA, !values.libroIva)
            }
          />
        </div>
      </div>
      <div
        key='footerIntegracionModal'
        className='tw-flex tw-flex-row tw-justify-end tw-pb-1 tw-gap-3 tw-mt-8'
      >
        <Button
          label={`${t("integracion.modal.cancel")}`}
          className='tw-w-32 tw-h-12 !tw-bg-inherit !tw-text-primary !tw-border-none tw-rounded-md'
          onClick={onCancel}
        />
        <Button
          label={`${t("integracion.modal.continuar")}`}
          className='tw-w-32 tw-h-12 !tw-bg-primary tw-text-simple-10 tw-rounded-md !tw-border-none'
          onClick={handleSubmit}
        />
      </div>
    </div>
  )
}

const ModalIntegracionForm = withFormik({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mapPropsToValues: ({ statusModal }: $TSMigrationFixMe) => {
    return {
      logo: statusModal.data.logo,
      type: statusModal.data.type,
      asientosContables: false,
      contactos: false,
      libroIva: false,
    }
  },
  handleSubmit: (values, { props }) => {
    if (values.asientosContables || values.contactos || values.libroIva)
      props.onConfirm(values)
    props.onCancel()
  },
})(ModalIntegracion)

export default ModalIntegracionForm
